import React, { forwardRef, useMemo } from 'react';
import moment from 'moment/moment';
import Field from '../../shared/forms/Field';
import FormMultiSelect from '../../shared/forms/FormFields/FormMultiSelect';
import FormDropDown from '../../shared/forms/FormFields/FormDropDown';
import FormCalendarRange from '../../shared/forms/FormFields/FormCalendarRange';
import FiltroV2, { LeftFilters, ModalFilters, RightFilters } from '../../shared/componentes/FiltroV2';
import constantes from '../../catalogos/constantes';
import WeekPicker from '../../shared/controls/WeekPicker';

const permisionarioOpciones = [
    { id: 1, nombre: 'Todos' },
    { id: 2, nombre: 'Permisionarios' },
    { id: 3, nombre: 'Ximple' },
];

const FiltrosEstatusDiarios = forwardRef(function FiltrosV2({ onApplyFilter, onMoveDays, fecha }, ref) {
    const maxDate = useMemo(() => moment().startOf('days').add(6, 'days'), []);

    const defaultFilter = {
        fecha: moment().format('YYYY-MM-DD'),
    };

    return (
        <div style={{ position: 'relative', flexGrow: 1, marginBottom: '10px' }}>
            <FiltroV2
                ref={ref}
                filtroKey="EstatusDiariosV2"
                defaultFilter={defaultFilter}
                onApplyFilter={onApplyFilter}
                modalTitle="Filtros adicionales"
                modalColumns={2}
            >
                <LeftFilters>
                    <Field
                        field="unidadIds"
                        label="Unidad"
                        source="unidadesParaEstatusDiarios"
                        render={FormMultiSelect}
                        showFilter
                        width={180}
                    />
                    <Field
                        field="tipoUnidadIds"
                        label="Tipo Unidad"
                        source="tiposUnidad"
                        render={FormMultiSelect}
                        width={180}
                    />
                    <Field
                        field="coordinadorIds"
                        label="Coordinadores"
                        source="empleados"
                        render={FormMultiSelect}
                        params={{ puestoIds: constantes.puestosDeTrafico, todasLasEmpresas: true }}
                        width={180}
                    />
                </LeftFilters>

                <ModalFilters>
                    <Field
                        field="unidadPermisionario"
                        label="Permisionarios"
                        options={permisionarioOpciones}
                        render={FormDropDown}
                        showClear
                    />
                    <Field
                        field="fechaHoy"
                        label="Fechas"
                        render={FormCalendarRange}
                        minDate={moment().startOf('day').toDate()}
                        maxDate={moment().endOf('day').toDate()}
                    />
                    <Field
                        field="municipios"
                        label="Ubicación"
                        source="municipiosUnidades"
                        render={FormMultiSelect}
                        showFilter
                    />
                    <Field
                        field="estacionUnidad"
                        label="Estación CSR"
                        source="estaciones"
                        render={FormMultiSelect}
                        showFilter
                    />
                </ModalFilters>

                <RightFilters>
                    <Field
                        field="_weekPicker"
                        render={({ value, onChange: _onChange, parent }) => (
                            <WeekPicker
                                date={parent?.fecha}
                                onMoveDays={onMoveDays}
                                maxDate={maxDate.toDate()}
                                inverted
                            />
                        )}
                    />
                </RightFilters>
            </FiltroV2>
        </div>
    );
});

export default FiltrosEstatusDiarios;
